import * as React from 'react';

type step = {
    step: number,
    stepsBarRef: React.RefObject<HTMLDivElement>,
};

export const StepsBar = ({step, stepsBarRef}: step) => {
    return (
        <>
            {step < 5 && (
                <div id="steps-bar" ref={stepsBarRef}>
                    <p className={"desktop-steps"}>{step} žingsnis iš 4</p>
                    <div className={"desktop-steps"}>
                        <div className={step >= 1 ? 'step active' : 'step'}>
                            <div>
                                <span className="step-number">1</span>
                                Nuotrauka<span className="sub-description">AI analizė</span>
                            </div>
                        </div>
                        <div className={step >= 2 ? 'step active' : 'step'}>
                            <div>
                                <span className="step-number">2</span>Vieta<span
                                className="sub-description">Aukštas ir liftas</span>
                            </div>
                        </div>
                        <div className={step >= 3 ? 'step active' : 'step'}>
                            <div>
                                <span className="step-number">3</span>Kada<span
                                className="sub-description">Adresas ir laikas</span>
                            </div>
                        </div>
                        <div className={step >= 4 ? 'step active' : 'step'}>
                            <div>
                        <span
                            className="step-number">4</span>Patvirtinti<span
                                className="sub-description">Santrauka ir užsakymas</span>
                            </div>
                        </div>
                    </div>

                    <div className="mobile-progress" aria-label="1 žingsnis iš 4">
                        <div className="progress-dots">
                            <span className={step >= 1 ? 'dot active' : 'dot'}></span>
                            <span className="line"></span>
                            <span className={step >= 2 ? 'dot active' : 'dot'}></span>
                            <span className="line"></span>
                            <span className={step >= 3 ? 'dot active' : 'dot'}></span>
                            <span className="line"></span>
                            <span className={step >= 4 ? 'dot active' : 'dot'}></span>
                        </div>
                        <div className="mobile-step-label"><strong>{step}/4</strong>
                            {step == 1 && ("Nuotrauka")}
                            {step == 2 && ("Vieta")}
                            {step == 3 && ("Kada")}
                            {step == 4 && ("Patvirtinti")}


                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
